import React, { useEffect } from "react";
import { UploadOutlined, PlusOutlined } from '@ant-design/icons';
import "./style.css";
import { Steps, theme, Upload, Modal, Form, Col, Row, } from 'antd';
import {
    getAnalogObjectsByProjectIdAction, uploadObjectFilesAction, createObjCharacteristicAction,
    clearProjectCreateAction
} from "../store/actions"
import Notifications from "../../../helpers/Notifications"
import CustomButton from "../../../components/CustomButton"
import { useState } from 'react';
import { uploadJsonLines } from "../store/actions"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom";
import AddPtmDescription from "./addPtmDescription";
import CustomInput from "../../../components/CustomInput";

const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });

const projectImgsEnum = {
    1: "mainImage",
    2: "image",
    3: "drawing",
    4: "explication",
    5: "resources"
};

const CreateProject = () => {
    const [current, setCurrent] = useState(0);
    const [formDesigner, setFormDesigner] = useState()
    const [formCustomer, setFormCustomer] = useState()
    const [previewOpen, setPreviewOpen] = useState(false);
    const [sucsessOpen, setSucsessOpen] = useState(false)
    const [previewImage, setPreviewImage] = useState('');
    const [previewTitle, setPreviewTitle] = useState('');
    const [descriptions, setDescriptions] = useState([]);
    const [canFinish, setCanFinish] = useState(false);

    const [form] = Form.useForm();
    const [formProj] = Form.useForm()
    const { t } = useTranslation(['common', 'valid', "action", "project"])
    const dispatch = useDispatch()
    const handleCancel = () => setPreviewOpen(false);
    const handleCancelSucsess = () => setSucsessOpen(false);
    const { token } = theme.useToken();
    const navigate = useNavigate();

    const {
        isLoading, createdProject, objectAnalogList, changedImages, changedJsonLines, savePtmDescription
    } = useSelector(state => state.projectReducer)

    const getObjectsAnalog = (values) => {
        dispatch(getAnalogObjectsByProjectIdAction(values))
    }

    const uploadObjectFiles = (values) => {
        dispatch(uploadObjectFilesAction(values))
    }

    const createObjCharacteristic = (values) => {
        dispatch(createObjCharacteristicAction(values))
    }

    useEffect(() => {
        setSucsessOpen(!!createdProject)
        if (createdProject) {
            getObjectsAnalog({
                analogProjectId: createdProject.analogProjectQ.id,
            })
        }
    }, [createdProject])

    useEffect(() => {
        if (changedJsonLines) {
            Notifications.successNotice(changedJsonLines, '', 10)
        }

    }, [changedJsonLines])

    useEffect(() => {
        if (changedImages) {
            Notifications.successNotice(changedImages, '', 10)
        }

    }, [changedImages])

    useEffect(() => {
        if (savePtmDescription) {
            Notifications.successNotice("Проект успешно добавлен!", '', 10)
            navigate(`/project/${createdProject.analogProjectQ.id}`)

            return () => {
                dispatch(clearProjectCreateAction())
            }
        }
    }, [savePtmDescription])

    useEffect(() => {
        setCanFinish(!!descriptions.length && descriptions.every(d => d.isParent || d.description) && formCustomer && formDesigner)
    }, [descriptions, formCustomer, formDesigner])

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
        setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
    };

    const normFile = (e) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e?.fileList;
    }

    function createFile() {
        return (event) => {
            if (event?.file) {
                const formData = new FormData()
                formData.append('JsonLineFile', event.file)
                dispatch(uploadJsonLines(formData))
            }
        }
    }

    const onFinish = (values) => {
        const object = new FormData()
        values["objectFiles"]?.forEach((objectFile) => {
            Object.entries(objectFile).forEach(([key, files]) => {
                if (Array.isArray(files)) {
                    files.forEach(file => {
                        object.append(key, file.originFileObj)
                    })
                }
            })
            object.append(`ObjectId`, objectFile.objectId)
        });
        uploadObjectFiles(object)
    }

    const createProject = () => {
        formProj?.validateFields().then(vals => {
            const updateValues = {
                analogProjectId: createdProject.analogProjectQ.id,
                customer: vals?.formCustomer,
                designer: vals?.formDesigner,
            }
            createObjCharacteristic({
                analogObjId: objectAnalogList[0].id, //пока берем только один объект
                objPtmCharacteristics: descriptions.filter(ptm => !ptm.isParent),
                ...updateValues
            })
        })
    };

    const getUploadFormItem = (name, fyncTypeIndex) => {
        const isRequired = ["1", "2", "3"].includes(fyncTypeIndex)

        return <Form.Item
            valuePropName="fileList"
            getValueFromEvent={normFile}
            name={[name, projectImgsEnum[fyncTypeIndex]]}
            className="project-upload-img"
            label={t(`project:projectImgTitles.${projectImgsEnum[fyncTypeIndex]}`)}
            rules={[{ required: isRequired, message: 'Необходимо выбрать изображение!' }]}
        >
            <Upload
                listType="picture-card"
                accept=".jpeg,.jpg,.raw,.tiff,.psd,.bmp,.gif,.png,.jp2"
                onPreview={handlePreview}
                maxCount={
                    fyncTypeIndex === "1" ? 1 : false
                }
                multiple={fyncTypeIndex !== "1"}
                beforeUpload={() => false}
            >
                <div>
                    <PlusOutlined />
                    <div style={{ marginTop: 8 }} >
                        {t("action:upload")}
                    </div>
                </div>
            </Upload>
        </Form.Item>
    }

    var steps = [
        {
            title: 'Загрузка файла проекта',
            content:
                <div>

                    <Upload
                        accept=".txt"
                        onChange={createFile()}
                        showUploadList={false}
                        maxCount={1}
                        customRequest={null}
                        beforeUpload={() => false}

                    >
                        <CustomButton type="green" icon={<UploadOutlined />} block shape="round"
                            disabled={changedJsonLines ? true : false}>
                            Загрузить файл проекта
                        </CustomButton>
                    </Upload>
                    <Modal open={sucsessOpen} title="Отчет о загрузка файла:" footer={null}
                        onCancel={handleCancelSucsess}>
                        {createdProject?.message}
                    </Modal>

                    <Modal open={isLoading} footer={null} closable={false} onCancel={null}>
                        <div className="loading-modal-wrapper">
                            <div className="loading-spinner mb-2"></div>
                            <div className="loading-text">Идёт загрузка файла проекта, пожалуйста, подождите...</div>
                        </div>
                    </Modal>

                </div>,
        },
        {
            title: 'Добавление изображений',
            content:
                objectAnalogList?.length ?
                    <div>
                        <Form
                            labelCol={{ span: 5 }}
                            wrapperCol={{ span: 1 }}
                            layout="horizontal"
                            autoComplete="off"
                            className="main-form"
                            onFinish={onFinish}
                            form={form}
                            name="objectFilesForm"
                            initialValues={{
                                objectFiles: objectAnalogList.map(({ id }) => (
                                    {
                                        objectId: id,
                                        main: [],
                                        images: [],
                                        drawing: [],
                                    }))
                                    ?? []
                            }}
                        >
                            <p className="project-title">{`Проект "${createdProject?.analogProjectQ.name}"`}</p>
                            <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
                                <img
                                    alt="example"
                                    style={{
                                        width: '100%',
                                    }}
                                    src={previewImage}
                                />
                            </Modal>
                            <Form.List
                                name="objectFiles"
                            >
                                {(fields, { add, remove }) => (<>
                                    {fields?.map(({ key, name, ...restField }, index) => (
                                        <div key={index}>
                                            <Form.Item name={[name, "objectId"]} hidden></Form.Item>
                                            {Object.entries(projectImgsEnum)
                                                .map(([key]) => getUploadFormItem(name, key))}
                                        </div>
                                    ))}

                                </>)}
                            </Form.List>
                            <CustomButton htmlType="submit" type="green" disabled={changedImages ? true : false}>
                                Загрузить изображения
                            </CustomButton>

                        </Form>
                    </div>
                    : 'Файл проекта не был загружен!',
        },
        {
            title: "Добавление описания ПТМ",
            content: createdProject ? (
                <>

                    <Form
                        labelCol={{
                            span: 5,
                        }}
                        wrapperCol={{
                            span: 15,
                        }}
                        layout="horizontal"
                        autoComplete="off"
                        className="main-form"
                        onFinish={onFinish}
                        form={formProj}
                        name="custDesigForm"
                        style={{ marginTop: "50px", marginBottom: "50px" }}
                    >
                        <Row>
                            <Col span={10}>
                                <Form.Item
                                    label="Заказчик:"
                                    name="formCustomer"
                                    rules={[
                                        {
                                            required: true,
                                        }
                                    ]}
                                >
                                    <CustomInput
                                        maxLength={250}
                                        onChange={e => setFormCustomer(e.target.value)}
                                        placeholder="Введите заказчика"
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={2}></Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Проектировщик:"
                                    name="formDesigner"
                                    rules={[
                                        {
                                            required: true,
                                        }
                                    ]}
                                >
                                    <CustomInput
                                        maxLength={250}
                                        onChange={e => setFormDesigner(e.target.value)}
                                        placeholder="Введите проектировщика"
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    <AddPtmDescription
                        descriptions={descriptions}
                        setDescriptions={setDescriptions}
                    />
                </>
            ) : (
                "Файл проекта не был загружен!"
            ),
        },
    ];

    const items = steps?.map((item) => ({
        key: item.title,
        title: item.title,
    }));

    const contentStyle = {
        lineHeight: '260px',
        textAlign: 'center',
        color: token.colorTextTertiary,
        //backgroundColor: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        //border: `1px dashed ${token.colorBorder}`,
        marginTop: 16,
    };

    return (
        <>
            <Steps className="steps-style" current={current} items={items} />
            <div style={contentStyle}>{steps[current].content}</div>
            <div className="navigation-btn">
                {current < steps.length - 1 && (
                    <CustomButton className="down-buttons-right" type="green" onClick={() => setCurrent(current + 1)}>
                        Следующий шаг
                    </CustomButton>
                )}
                {(current === steps.length - 1 && canFinish) && (
                    <CustomButton type="green" className="down-buttons-right" onClick={() => createProject()}>
                        Завершить создание
                    </CustomButton>
                )}
                {current > 0 && (
                    <CustomButton
                        className="down-buttons-left"
                        onClick={() => setCurrent(current - 1)}
                    >
                        Предыдущий шаг
                    </CustomButton>
                )}
            </div>
        </>
    );

}


export default CreateProject;
